<template>
  <loader v-bind="{ loading }">
    <columns class="is-mobile">
      <div class="column is-narrow">
        <pager button-class="is-rounded" v-if="issues.data.length" :pageable="issues" @nav="goTo" jump-controls/>
      </div>
      <column>
        <search-bar 
          v-model="filters.search"
          :searching="searching"
          @run-search="runSearch"
          @clear-search="clearSearch"/>
      </column>
    </columns>

    <columns>
      <column>
        <index-row 
          :title="attribute.type.title" 
          :route="{
          name: 'attribute-manager',
          params: {
            ...$route.params,
            attribute: attribute.id
          }}"
          v-for="attribute in issues.data" :key="attribute.id">
          <p class="help">
            <span>Latest update {{ attribute.updated_at | asCalendar }}</span><span v-if="attribute.changes.length > 0">, {{ attribute.changes.length }} revision<span v-if="attribute.changes.length !== 1">s</span></span>
          </p>
          <template #right>
            <flex>
              <attribute-status class="mr-2" :attribute="attribute"/>
            </flex>
          </template>
        </index-row>  
        <pager button-class="is-rounded" v-if="issues.data.length" :pageable="issues" @nav="goTo" jump-controls/>
      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'
import AttributeStatus from '@/views/attribute/partials/Status'

export default {

  name: 'EnvironmentAttributes',

  components: {
    AttributeStatus
  },

  data: () => ({
    issues: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Attributes')
  },

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadItems()
  },

  methods: {
    loadItems() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({data}) => {
        this.issues = data
        this.loading = false
        this.searching = false
      }, error => {
        console.log(error)
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    runSearch() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.searching = true
      this.$router.push({
        name: 'environment-attributes',
        params: this.$route.params,
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'environment-attributes',
        params: this.$route.params,
        query: {}
      })
    },
  },

  watch: {
    '$route': 'loadItems'
  }
}
</script>
